jQuery( document ).ready(function( $ ) {

if ( $( document ).width() <= 767 )
{
	// Ajout des classes CSS
	$( '#mp-menu .sub-menu' ).each(function(){
		$( this ).wrap( '<div class="mp-level"></div>' );
	});

	// Ajout de sélecteur de langue, du bouton de retour et de la recherche
	$( '#mp-menu .mp-level' ).each(function(){
		$( this ).prepend( $( '#masthead #language-selector' ).clone() );
		$( this ).prepend( '<a class="mp-back" href="#">back</a>' );
		$( this ).append( $( '#masthead .search-form' ).clone() );
	});
	
	// Ajout en sous-niveau des parents non cliquables nativement
	$( '#mp-menu li.menu-item-has-children > a' ).each(function(){
		if ( $( this ).attr( 'href' ) != '#' )
			$( '> .mp-level > .sub-menu', $( this ).parent() ).prepend( $( this ).clone().addClass( 'new-elt' ) );	
	});
	$( '.new-elt' ).wrap( '<li class="menu-item menu-item-type-post_type menu-item-object-page"></li>' );

	// new mlPushMenu( document.getElementById( 'mp-menu' ), document.getElementById( 'trigger' ), { levelSpacing: 25 } );

	if ( $( '#masonry .flexslider' ).length )
	{
		var itemWidth = $( '#main' ).width();
		$( '#masonry .flexslider' ).flexslider({
			slideshow: false,
			animation: 'slide',
			directionNav: false,
			slideshowSpeed: 6000,
			animationSpeed: 500,
			itemMargin: 40,
			itemWidth: itemWidth
		});
	}
	
	$( '.search-results-posts .search_posttype_title, .search-results-faqs .search_posttype_title' ).addClass( 'close' );
	$( 'body' ) .on( 'click', '.search_posttype_title', function()
	{
		if ( $( this ).hasClass( 'close' ) )
		{
			$( 'article', $( this ).parent() ).fadeIn();
			$( this ).removeClass( 'close' );
		}
		else
		{
			$( 'article', $( this ).parent() ).fadeOut();
			$( this ).addClass( 'close' );			
		}
	});
}

});